/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import { MCP_SERVERS_FILTER, entityToEntry, type McpCatalogEntry } from './entries';

/** Vetted MCP servers, sorted by title. `retry` refetches after an error. */
export function useMcpServers(): {
  value?: McpCatalogEntry[];
  loading: boolean;
  error?: Error;
  retry: () => void;
} {
  const catalogApi = useApi(catalogApiRef);
  return useAsyncRetry(async () => {
    const { items } = await catalogApi.getEntities({ filter: { ...MCP_SERVERS_FILTER } });
    return items
      .map(entityToEntry)
      .filter((e): e is McpCatalogEntry => e !== undefined)
      .sort((a, b) => a.descriptor.title.localeCompare(b.descriptor.title));
  }, [catalogApi]);
}
